import BaseClient, { type ExtendedAxiosRequestConfig } from '../BaseClient';
import type { ScheduledMessagesClientInterface, ScheduledMessage } from './scheduledMessagesClient.types';
import type { CursorPaginationResponse, QueryParams } from '~/services/api';
import type { AxiosPromise } from 'axios';

export default class CorporateScheduledMessagesClient extends BaseClient implements ScheduledMessagesClientInterface {
    constructor(private teamId: number) {
        super();
    }

    getScheduledMessages(
        params?: QueryParams,
        config?: ExtendedAxiosRequestConfig
    ): AxiosPromise<CursorPaginationResponse<ScheduledMessage>> {
        const url = `/api/v3/teams/${this.teamId}/scheduled-messages`;
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }

    getScheduledMessagesCount(config?: ExtendedAxiosRequestConfig): AxiosPromise<{ count: number }> {
        const url = `/api/v3/teams/${this.teamId}/scheduled-messages/count`;
        return this.makeCoreApiRequest(url, 'get', null, {}, config);
    }

    getContactScheduledMessages(
        contactId: number,
        params?: QueryParams,
        config?: ExtendedAxiosRequestConfig
    ): AxiosPromise<CursorPaginationResponse<ScheduledMessage>> {
        const url = `/api/v3/teams/${this.teamId}/contacts/${contactId}/scheduled-messages`;
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }

    createScheduledMessage(contactId: number, data: ScheduledMessage): AxiosPromise<ScheduledMessage> {
        const url = `/api/v3/teams/${this.teamId}/contacts/${contactId}/scheduled-messages`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    deleteScheduledMessage(contactId: number, scheduledMessageId: number): AxiosPromise<void> {
        const url = `/api/v3/teams/${this.teamId}/contacts/${contactId}/scheduled-messages/${scheduledMessageId}`;
        return this.makeCoreApiRequest(url, 'delete');
    }
}
